var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("Outbox")]),_c('div',[_vm._v(_vm._s(_vm.numUnsent))]),_c('dimssa-button',{on:{"onclick":function($event){return _vm.onClickResend()}}},[_vm._v("Resend")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }